<template lang="pug">
.tg-chat-composer
  form-line
    form-cell(cols="12"): f-textarea(
      name="text"
      :data="messageForm"
      :super-label="_('Message')"
      :readonly="isSendingMessage || !canSendMessage"
    )

  form-line
    form-cell(cols="narrow")
      control-button(
        styling="primary"
        :disabled="isSendingMessage || !canSendMessage || !trimmedMessageText"
        @click.prevent="emitSend"
      ) {{ _('Send') }}

    form-cell(cols="narrow")
      control-button(
        styling="default"
        :disabled="isRefreshDisabled"
        @click.prevent="emitRefresh"
      ) {{ _('Refresh') }}
</template>

<script>
export default {
  props: {
    messageForm: {
      type: Object,
      required: true,
    },
    isSendingMessage: {
      type: Boolean,
      default: false,
    },
    canSendMessage: {
      type: Boolean,
      default: false,
    },
    isRefreshDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    trimmedMessageText() {
      return (this.messageForm?.text || '').trim()
    },
  },

  methods: {
    emitSend() {
      this.$emit('send')
    },

    emitRefresh() {
      this.$emit('refresh')
    },
  },
}
</script>
